<template>
  <div class="container mt-5">
    <div class="mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="card shadow p-3 mb-5 bg-white rounded border-0">
            <div class="card-body m-2">
              <div v-if="loading" class="text-center p-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div v-if="error" class="alert alert-danger">
                {{ error }}
              </div>

              <div v-if="policy" class="card shadow-sm border-light">
                <div class="card-header bg-light p-4">
                  <h1 class="h3 card-title mb-0">{{ policy.name }}</h1>
                  <p class="card-subtitle text-muted mt-1">
                    Version: {{ policy.version }}
                  </p>
                </div>
                <div class="card-body p-4">
                  <div class="row">
                    <div class="col-sm-6">
                    <strong>Policy Owner:</strong> {{ policy.owner_name || 'N/A' }}
                  </div>
                    <div class="col-sm-6 mt-2">
                      <strong>Version Date:</strong> {{ formatDisplayDate(policy.date_uploaded) }}
                    </div>
                    <div class="col-sm-6">
                      <strong>Version Uploaded By:</strong> {{ policy.from_alke ? 'From Alke' : (policy.updated_by_name || 'N/A') }}
                    </div>
                  </div>

                  <div v-if="policy.link" class="my-4">
                    <button @click="viewPolicy" class="btn btn-primary">
                      View Policy
                    </button>
                  </div>

                  <div v-else>
                    <p class="text-muted">No previewable content available for this policy.</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PolicyPreviewPage',
  data() {
    return {
      policy: null,
      loading: false,
      error: null,
    };
  },
  mounted() {
    this.fetchPolicy();
  },
  methods: {
    async fetchPolicy() {
      this.loading = true;
      this.error = null;
      const policyId = this.$route.params.id; // Get ID from URL

      if (!policyId) {
        this.error = "No policy ID provided.";
        this.loading = false;
        return;
      }

      try {
        const orgId = this.$helper.setOrganisationID();
        const response = await axios.get(`/orgadmin/trainings/organisations/${orgId}/training-policy/history/${policyId}`);

        if (response.data.success) {
          this.policy = response.data.policy;

          if (this.policy) {
            const userFetchPromises = [];

            // Prepare to fetch 'updated_by' user info
            if (this.policy.updated_by) {
              userFetchPromises.push(
                axios.get(`/users/${this.policy.updated_by}/basic-info`).then(res => {
                  this.policy.updated_by_name = `${res.data.user.first_name} ${res.data.user.last_name}`;
                }).catch(err => {
                  console.error(`Failed to fetch user info for ID ${this.policy.updated_by}:`, err);
                  this.policy.updated_by_name = 'Unknown User';
                })
              );
            }

            // Prepare to fetch 'owner' user info
            if (this.policy.owner && this.policy.owner !== 0) {
              userFetchPromises.push(
                axios.get(`/users/${this.policy.owner}/basic-info`).then(res => {
                  this.policy.owner_name = `${res.data.user.first_name} ${res.data.user.last_name}`;
                }).catch(err => {
                  console.error(`Failed to fetch user info for owner ID ${this.policy.owner}:`, err);
                  this.policy.owner_name = 'Unknown User';
                })
              );
            }

            await Promise.all(userFetchPromises);
          }

        } else {
          this.error = response.data.message || "Failed to load policy.";
        }
      } catch (err) {
        console.error("Error fetching policy:", err);
        this.error = "An error occurred while trying to load the policy.";
      } finally {
        this.loading = false;
      }
    },
    formatDisplayDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
      } catch (error) {
        return dateString;
      }
    },
    viewPolicy() {
      if (this.policy?.link) {
        let url = this.policy.link;
        // Ensure the URL has a protocol, otherwise it's treated as a relative path.
        if (!url.match(/^https?:\/\//) && !url.startsWith('/')) {
          // We'll default to https for security.
          url = `https://${url}`;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
  }
};
</script>

<style scoped>
.policy-content-wrapper {
  background-color: #f8f9fa;
}
/* This ensures any HTML content from your "alke" template formats nicely */
.policy-content-wrapper :deep(h1) { font-size: 1.5rem; margin-top: 1rem; }
.policy-content-wrapper :deep(h2) { font-size: 1.25rem; margin-top: 1rem; }
.policy-content-wrapper :deep(p) { margin-bottom: 1rem; }
.policy-content-wrapper :deep(ul) { padding-left: 2rem; }
</style>
